import { NotificationService } from 'src/app/shared/services/notification.service';
import { inject, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BaseServices } from 'src/app/kuba/kuba.services';

import { Rights } from 'src/app/_models';
import { ConfirmationService } from 'primeng/api';
import { QualitySystem, QualitySystemUsers } from '../models/quality-system';
import { QualitySystemService } from '../services/quality-system.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-quality-system-list',
  templateUrl: './quality-system-list.component.html',
  standalone: false
})
export class QualitySystemListComponent implements OnInit {
  private readonly notifications = inject(NotificationService);
  qualitySystemList: QualitySystem[];
  isAdministrateQs = true;
  isHideDeleteIcon = true;
  additionalData: any;
  isDisabled: boolean;

  assignedUsers: QualitySystemUsers[] = [];
  showDialog = false;

  private subscriptions: Subscription[] = [];

  /**
   *
   * @param qualitySystemService {{qualitySystemServices}}
   * @param confirmationService {{ConfirmationService}}
   * @param route {{ActivatedRoute}}
   * @param intrnlcntrlsrvc {{InternalControlServices}}
   */
  constructor(
    private qualitySystemService: QualitySystemService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private router: Router
  ) {}

  /**
   * Initializes the page and handles auto redirect routing
   */
  ngOnInit() {
    document.querySelector('body').classList.remove('opened');
    this.isDisabled = true;
    let qualitySystems = this.route.snapshot.data['list'];

    if (qualitySystems != null) {
      this.qualitySystemList = qualitySystems;
    }
    this.onAdministrateQualitySystem();
    let qs = sessionStorage.getItem('checkParent');

    if (qualitySystems.length === 1) {
      if (qs === 'QS') {
        this.router.navigate(['./../../list'], { relativeTo: this.route });
      } else {
        const qualitySystem: QualitySystem = qualitySystems[0];
        this.autoRedirectToQs(qualitySystem);
      }
    }
    sessionStorage.setItem('checkParent', null);

    this.subscriptions.push(
      this.translate.stream('FILENAME').subscribe(val => {
        this.additionalData = {
          fileName: val.QUALITY_SYSTEMS_LIST,
          header: 'Quality System List',
          businessId: BaseServices.BusinessId,
          cultureInfo: BaseServices.userCultureInfo(),
          columnNames: [
            { title: 'Name of the task', dataKey: 'Title' },
            { title: 'Description', dataKey: 'Description' },
            { title: 'Assigned Access', dataKey: 'UserCount' },
            { title: 'Deviations In Followup', dataKey: 'ShowDeviationreport' }
          ]
        };
      })
    );
  }

  /**
   * Navigates the user to the Quality System if they have access to it.
   * If not, they will likely just see an empty list.
   * @param qualitySystem QS to navigate to
   */
  autoRedirectToQs(qualitySystem: QualitySystem) {
    if (this.isAdministrateQs) {
      this.router.navigate(['./../../details/' + qualitySystem.Id], {
        relativeTo: this.route
      });
    } else {
      const userId = BaseServices.UserId;
      if (qualitySystem.QualitySystemUsers.find(qsu => qsu.UserId === userId)) {
        this.router.navigate(['./../../details/' + qualitySystem.Id], {
          relativeTo: this.route
        });
      }
    }
  }

  onHide() {
    this.showDialog = false;
  }

  /**
   * Opens a popup showing the assigned users in an Quality System
   * @param assignedUsers Assigned users in a QS
   */
  showAssignedUsers(assignedUsers: QualitySystemUsers[]) {
    this.showDialog = true;
    this.assignedUsers = [];
    this.assignedUsers = assignedUsers;
  }

  /**
   * gets list of all Quality Systems
   */
  getAllQualitySystems() {
    this.subscriptions.push(
      this.qualitySystemService
        .getAll(BaseServices.BusinessId)
        .subscribe(result => {
          this.qualitySystemList = result;
        })
    );
  }

  /**
   * delete internal control
   * @param control {{any}}
   */
  confirm(control) {
    this.confirmationService.confirm({
      message: this.translate.instant('DELETE_THIS_RECORD'),
      accept: () => {
        this.qualitySystemService.deleteControl(control).then(result => {
          if (result) {
            this.notifications.success('UI_NOTIFICATIONS.DELETED');
            this.getAllQualitySystems();
          }
        });
      }
    });
  }

  /**
   * Edit & update Ic based on administrateIC rights
   */
  onAdministrateQualitySystem() {
    let userRightsId = Rights.ADMINISTRATE_QUALITY_SYSTEM;
    let role = BaseServices.UserRole;
    if (role === 'User') {
      this.isHideDeleteIcon = false;
      this.isAdministrateQs = BaseServices.checkUserRights(userRightsId, role);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub, i) => {
      sub.unsubscribe();
    });
  }
}
